export class Service {
  id?: number;
  name?: string;
  description?: string;
  agencyName?: string;
  prix?: string;
  imageUrl?: string;
  status?: string;
  categorie?: string;
  categoryList?: string[];
  promoTitle?: string;
  promoImg?: string;
  videoUrl?: string;
  hasAtelier?: boolean;   // <-- added
}